module.exports = __webpack_public_path__ + "static/media/1.f3ebe848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16461/1.jpg
// module id = 559
// module chunks = 0